var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInnedit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 70 13",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.496074,0,0,0.496074,-63.5084,-21.931)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.4979,0,0,0.4979,214.372,63.3731)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-16.347L0,13.077L-6.866,13.071L-6.866,-14.238C-6.866,-19.188 -8.452,-22.774 -13.188,-22.774C-17.923,-22.774 -20.346,-19.091 -20.346,-14.141L-20.346,13.071L-27.215,13.077L-27.215,-16.347C-27.215,-23.772 -20.612,-29.424 -13.188,-29.424C-5.761,-29.424 0,-23.772 0,-16.347",
    style: {
      fill: "rgb(87,87,87)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.4979,0,0,0.4979,197.098,63.3731)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-16.347L0,13.077L-6.863,13.071L-6.863,-14.238C-6.863,-19.188 -8.449,-22.774 -13.185,-22.774C-17.92,-22.774 -20.344,-19.091 -20.344,-14.141L-20.344,13.071L-27.212,13.077L-27.212,-16.347C-27.212,-23.772 -20.611,-29.424 -13.185,-29.424C-5.76,-29.424 0,-23.772 0,-16.347",
    style: {
      fill: "rgb(87,87,87)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.4979,0,0,0.4979,-19.1922,-83.9275)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 545.525,
    y: 267.189,
    width: 6.716,
    height: 41.726,
    style: {
      fill: "rgb(87,87,87)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.4979,0,0,0.4979,268.776,47.4408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,39.074L0,45.07C-3.198,45.07 -5.703,44.683 -7.514,43.91C-9.326,43.138 -10.699,42.22 -11.633,41.152C-12.563,40.088 -13.137,39.01 -13.35,37.916C-13.563,36.823 -13.669,35.984 -13.669,35.398L-13.669,33.961L-13.669,8.955L-18.784,8.955L-18.784,3.282L-13.669,3.282L-13.669,-5.996L-6.875,-5.996L-6.875,3.282L0,3.282L0,8.955L-6.875,8.955L-6.875,34.039C-6.875,34.517 -6.807,35.039 -6.675,35.597C-6.54,36.157 -6.236,36.705 -5.754,37.235C-5.274,37.769 -4.597,38.211 -3.717,38.554C-2.838,38.902 -1.679,39.074 -0.24,39.074L0,39.074Z",
    style: {
      fill: "rgb(87,87,87)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.4979,0,0,0.4979,228.186,64.0701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-18.384C0,-17.105 -0.454,-16.026 -1.36,-15.147C-2.267,-14.266 -3.331,-13.829 -4.557,-13.829L-13.668,-13.807L-13.668,-19.904C-13.668,-20.33 -13.59,-20.823 -13.429,-21.381C-13.268,-21.942 -12.938,-22.461 -12.43,-22.942C-11.925,-23.42 -11.204,-23.833 -10.271,-24.178C-9.34,-24.527 -8.128,-24.698 -6.635,-24.698C-5.194,-24.698 -4.037,-24.527 -3.157,-24.178C-2.278,-23.833 -1.6,-23.406 -1.12,-22.901C-0.641,-22.394 -0.335,-21.862 -0.2,-21.301C-0.067,-20.742 0,-20.222 0,-19.743L0,-18.384ZM-1.838,5.036C-2.145,5.273 -2.718,5.583 -3.518,5.874C-4.316,6.169 -5.436,6.316 -6.874,6.316C-7.888,6.316 -8.741,6.236 -9.434,6.075C-10.126,5.915 -10.685,5.73 -11.11,5.516C-11.59,5.304 -11.964,5.064 -12.231,4.797C-12.498,4.531 -12.739,4.21 -12.949,3.836C-13.429,3.091 -13.668,2.052 -13.668,0.72L-13.668,-8.136L-2.317,-8.149C-2.317,-8.149 -0.854,-8.179 -0.16,-8.393C0.428,-8.551 1.078,-8.792 1.796,-9.114C2.517,-9.432 3.198,-9.913 3.836,-10.551C5.116,-11.831 5.914,-13.029 6.233,-14.147C6.555,-15.268 6.713,-16.278 6.713,-17.184L6.713,-21.022C6.713,-21.609 6.606,-22.448 6.396,-23.54C6.183,-24.632 5.621,-25.712 4.716,-26.778C3.81,-27.843 2.452,-28.761 0.639,-29.536C-1.173,-30.308 -3.677,-30.694 -6.874,-30.694C-10.072,-30.694 -12.577,-30.308 -14.389,-29.536C-16.2,-28.761 -17.56,-27.843 -18.464,-26.778C-19.372,-25.712 -19.933,-24.645 -20.143,-23.581C-20.355,-22.513 -20.463,-21.661 -20.463,-21.022L-20.463,2.558C-20.463,4.37 -19.985,5.995 -19.026,7.435C-18.599,8.074 -18.065,8.688 -17.426,9.274C-16.787,9.86 -15.987,10.38 -15.027,10.831C-14.069,11.284 -12.923,11.645 -11.59,11.911C-10.259,12.177 -8.688,12.31 -6.874,12.31C-4.37,12.31 -2.319,12.072 -0.721,11.591C0.88,11.111 2.131,10.551 3.036,9.913C4.315,9.007 5.248,7.943 5.834,6.714C6.421,5.49 6.713,4.158 6.713,2.718L6.713,0.8L-0.001,0.8C-0.001,1.652 -0.133,2.439 -0.399,3.158C-0.668,3.877 -1.146,4.503 -1.838,5.036",
    style: {
      fill: "rgb(87,87,87)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.4979,0,0,0.4979,-19.1922,-83.9275)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 393.195,
    y: 267.189,
    width: 6.714,
    height: 41.726,
    style: {
      fill: "rgb(87,87,87)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.4979,0,0,0.4979,180.021,46.2205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.001C0,1.964 -1.592,3.555 -3.556,3.555C-5.519,3.555 -7.11,1.964 -7.11,-0.001C-7.11,-1.964 -5.519,-3.556 -3.556,-3.556C-1.592,-3.556 0,-1.964 0,-0.001",
    style: {
      fill: "rgb(87,87,87)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.4979,0,0,0.4979,255.867,46.2205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.001C0,1.964 -1.592,3.555 -3.557,3.555C-5.52,3.555 -7.111,1.964 -7.111,-0.001C-7.111,-1.964 -5.52,-3.556 -3.557,-3.556C-1.592,-3.556 0,-1.964 0,-0.001",
    style: {
      fill: "rgb(87,87,87)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.4979,0,0,0.4979,244.81,49.0201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,33.402C-0.213,33.988 -0.572,34.521 -1.08,35C-1.585,35.48 -2.28,35.867 -3.157,36.158C-4.036,36.453 -5.143,36.6 -6.477,36.6C-7.753,36.6 -8.831,36.453 -9.711,36.158C-10.593,35.867 -11.285,35.48 -11.791,35C-12.297,34.521 -12.667,33.962 -12.908,33.322C-13.149,32.681 -13.297,32.015 -13.348,31.322L-13.348,10.584C-13.348,10.159 -13.269,9.664 -13.108,9.108C-12.948,8.547 -12.617,8.027 -12.111,7.547C-11.604,7.069 -10.884,6.655 -9.952,6.309C-9.047,5.972 -7.875,5.799 -6.439,5.79L0.318,5.789L0.318,31.724C0.318,32.256 0.214,32.816 0,33.402M0.318,-9.191L0.318,0.083L-6.555,0.083C-9.752,0.083 -12.259,0.47 -14.068,1.241C-15.881,2.015 -17.241,2.932 -18.145,3.999C-19.051,5.065 -19.612,6.132 -19.822,7.196C-20.035,8.263 -20.144,9.114 -20.144,9.755L-20.144,32.922C-20.144,34.256 -19.893,35.506 -19.385,36.678C-18.878,37.852 -18.063,38.877 -16.945,39.756C-15.828,40.636 -14.4,41.33 -12.667,41.836C-10.937,42.34 -8.874,42.593 -6.477,42.593C-1.838,42.593 1.571,41.674 3.758,39.837C5.94,37.998 7.063,35.693 7.112,32.922L7.112,-9.191L0.318,-9.191Z",
    style: {
      fill: "rgb(87,87,87)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.333454,0,0,0.333454,128.376,38.3051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.763,18.505C93.45,18.526 97.915,19.229 101.16,20.61C104.457,22.021 106.93,23.689 108.578,25.629C110.223,27.569 111.242,29.533 111.63,31.52C112.016,33.506 112.21,35.032 112.21,36.101L112.21,43.081C112.21,44.732 111.922,46.57 111.337,48.606C110.758,50.64 109.305,52.822 106.978,55.15C105.816,56.309 104.576,57.187 103.267,57.766C101.959,58.349 100.775,58.787 99.707,59.075C98.444,59.464 95.073,59.401 95.073,59.401L62.773,59.38L62.773,36.101C62.773,34.937 62.968,33.388 63.355,31.445C63.739,29.509 64.759,27.569 66.409,25.629C68.054,23.689 70.528,22.021 73.823,20.61C77.118,19.207 81.675,18.504 87.492,18.504L87.763,18.505ZM87.742,27.531C84.891,27.544 82.466,27.834 80.377,28.537C78.463,29.191 76.847,29.99 75.536,31.113C74.32,32.159 73.363,33.455 72.891,34.961C72.539,36.081 72.333,37.159 72.33,38.239L72.33,51.11L91.664,51.071C94.487,51.091 97.199,50.077 99.301,48.191C101.464,46.325 102.74,43.606 102.703,40.762L102.703,38.505C102.703,37.421 102.535,36.335 102.252,35.232C101.848,33.699 100.963,32.379 99.822,31.284C98.563,30.079 96.982,29.219 95.134,28.553C93.083,27.823 90.697,27.535 87.878,27.531L87.742,27.531Z",
    style: {
      fill: "rgb(87,87,87)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.339875,0,0,0.339875,140.439,54.6426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.002C0,2.329 -1.886,4.214 -4.213,4.214C-6.54,4.214 -8.426,2.329 -8.426,0.002C-8.426,-2.327 -6.54,-4.212 -4.213,-4.212C-1.886,-4.212 0,-2.327 0,0.002",
    style: {
      fill: "rgb(87,87,87)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.339875,0.00057722,0.00057722,-0.339875,141.68,70.172)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.005,
    y: -0.008,
    width: 9.431,
    height: 6.018,
    style: {
      fill: "rgb(87,87,87)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.339875,0,0,0.339875,144.884,62.2474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-29.181L-0.001,-29.181C-1.32,-43.137 -10.281,-52.521 -23.534,-52.521C-36.789,-52.521 -48.571,-42.431 -48.571,-29.181L-48.571,23.34L-39.142,23.326L-39.142,-25.243C-39.137,-30.109 -37.968,-34.586 -35.326,-37.999C-32.706,-41.425 -28.492,-43.52 -23.534,-43.482C-21.07,-43.484 -18.839,-43.01 -16.927,-42.036C-15.012,-41.072 -13.468,-39.611 -12.355,-37.894C-10.646,-35.241 -10.11,-32.073 -9.555,-28.635L-9.555,-28.612L-6.958,-6.039L-6.958,-6.037L-6.403,-1.202L-9.422,-1.202L-9.422,11.215L-0.001,11.215L-0.001,2.914L3.602,2.914L0,-29.181Z",
    style: {
      fill: "rgb(87,87,87)",
      fillRule: "nonzero"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnedit);
export default __webpack_public_path__ + "static/media/innedit.ef0fabc833c740d41024446c73d2a3c9.svg";
export { ForwardRef as ReactComponent };